<template>
  <!-- 多方式報到/簽退彈窗 -->
  <div id="multipleUnitOwnerDialog_main">
    <el-dialog
      :title="dialogTitle()"
      :visible.sync="dialogVisible"
      width="60%"
      :close-on-click-modal="afterSubmit"
      @closed="closeDialog"
    >
      <!-- 可報到／簽退戶別清單 -->
      <el-table
        ref="multipleUnitOwnerTable"
        :key="key"
        :data="list"
        :empty-text="'查無可' + actiontype + '戶別'"
        @selection-change="handleSelectionChange"
        @row-click="toggleSelection"
      >
        <el-table-column
          v-if="!loading && !afterSubmit"
          type="selection"
          min-width="55"
        />
        <el-table-column
          label="戶別"
          prop="tabletName"
          min-width="120"
        />
        <el-table-column
          label="區權人姓名"
          prop="name"
          min-width="120"
        />
        <el-table-column
          label="坪數"
          prop="tabletArea"
          min-width="60"
        />
        <el-table-column
          label="區分所有權佔比"
          prop="tabletAreaRatio"
          min-width="120"
        />
        <el-table-column
          v-if="afterSubmit"
          :label="actiontype + '結果'"
          min-width="60"
        >
          <template slot-scope="scope">
            <span :class="[scope.row.status == 'success' ? 'result_success' : '', scope.row.status =='fail' ? 'result_fail' : '']">{{ result(scope.row.status) }}</span>
          </template>
        </el-table-column>
      </el-table>
      <!-- /可報到／簽退戶別清單 -->
      <el-button
        v-if="list.length > 0 && !loading && !afterSubmit"
        type="primary"
        round
        @click="submit"
      >
        {{ actiontype }}
      </el-button>
      <el-button
        v-if="loading"
        round
      >
        {{ actiontype }}中...
      </el-button>
      <el-button
        v-if="finishSubmit"
        round
        @click="dialogVisible = false"
      >
        關閉
      </el-button>
      <!-- 異常清單 -->
      <div v-if="errorList.length > 0 && !afterSubmit">
        <div class="tableTitle">
          {{ actiontype }}失敗清單
        </div>
        <el-table :data="errorList">
          <el-table-column
            label="戶別"
            prop="tabletName"
            min-width="120"
          >
            <template slot-scope="scope">
              {{ scope.row.tabletNameOrCode || scope.row.tabletName }}
            </template>
          </el-table-column>
          <el-table-column
            label="區權人姓名"
            prop="name"
            min-width="120"
          />
          <el-table-column
            label="坪數"
            prop="tabletArea"
            min-width="50"
          />
          <el-table-column
            label="區分所有權佔比"
            prop="tabletAreaRatio"
            min-width="100"
          />
          <el-table-column
            label="失敗原因"
            min-width="100"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.registrationStatus">
                <span v-if="scope.row.registrationStatus == 'NotRegistered'">未報到</span>
                <span v-if="scope.row.registrationStatus == 'Registered'">已報到</span>
                <span v-if="scope.row.registrationStatus == 'Unregistered'">已簽退</span>
              </div>
              <div v-if="scope.row.errorMessage">
                {{ scope.row.errorMessage }}
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- /異常清單 -->
    </el-dialog>
  </div>
</template>
<script>
import RegisterUnitOwner from '../../mixins/RegisterUnitOwner'
import UnregisterUnitOwner from '../../mixins/UnregisterUnitOwner'

export default {
  mixins: [
    RegisterUnitOwner,
    UnregisterUnitOwner
  ],
  data () {
    return {
      dialogVisible: false,
      list: [],
      errorList: [],
      multipleSelection: [],
      actiontype: '',
      afterSubmit: false,
      finishSubmit: false,
      loading: false,
      key: '-2'
    }
  },
  methods: {
    openDialog (list, actiontype) {
      this.loading = true
      this.dialogVisible = true
      this.actiontype = actiontype
      // eslint-disable-next-line eqeqeq
      if (actiontype == '報到') {
        // 處理報到table data
        // eslint-disable-next-line eqeqeq
        this.list = list.successUnitOwnerCards.filter(item => item.registrationStatus == 'NotRegistered')
        // eslint-disable-next-line eqeqeq
        this.errorList = list.successUnitOwnerCards.filter(item => item.registrationStatus != 'NotRegistered')
      } else {
        // 處理簽退table data
        // eslint-disable-next-line eqeqeq
        this.list = list.successUnitOwnerCards.filter(item => item.registrationStatus == 'Registered')
        // eslint-disable-next-line eqeqeq
        this.errorList = list.successUnitOwnerCards.filter(item => item.registrationStatus != 'Registered')
      }
      this.list.map(item => {
        item.tabletAreaRatio = (item.tabletAreaRatio * 100).toFixed(2) < 0.01 ? '＜0.01％' : (item.tabletAreaRatio * 100).toFixed(2) + '％'
        item.status = 'waiting'
      })
      this.errorList.map(item => item.tabletAreaRatio = (item.tabletAreaRatio * 100).toFixed(2) < 0.01 ? '＜0.01％' : (item.tabletAreaRatio * 100).toFixed(2) + '％')
      this.errorList = this.errorList.concat(list.failUnitOwnerCards)
      this.$nextTick(() => {
        this.$refs.multipleUnitOwnerTable.toggleAllSelection()
        this.loading = false
      })
    },
    // 報到 or 簽退
    async submit () {
      // eslint-disable-next-line eqeqeq
      if (this.multipleSelection.length == 0) {
        this.$message.error('請勾選' + this.actiontype + '戶別')
        return
      }
      this.key = '-1'
      this.loading = true
      this.afterSubmit = true
      this.list = this.multipleSelection
      for (const i in this.list) {
        let res = {}
        // eslint-disable-next-line eqeqeq
        if (this.actiontype == '報到') {
          res = await this.RegisterUnitOwner({
            assemblyId: this.$route.params.id,
            unitOwnerId: this.list[i].id
          })
          // eslint-disable-next-line eqeqeq
          if (res.status == 200) { this.$emit('value-change', '報到', this.list[i].id, '本人') }
        } else {
          res = await this.UnregisterUnitOwner({
            assemblyId: this.$route.params.id,
            unitOwnerId: this.list[i].id
          })
          // eslint-disable-next-line eqeqeq
          if (res.status == 200) { this.$emit('value-change', '簽退', this.list[i].id) }
        }
        console.log(res)
        // eslint-disable-next-line eqeqeq
        this.list[i].status = res.status == 200 ? 'success' : 'fail'
        this.key = i
        // eslint-disable-next-line eqeqeq
        if ((this.list.length - 1) == i) {
          this.loading = false
          this.finishSubmit = true
        }
      }
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    toggleSelection (row) {
      if (row) { this.$refs.multipleUnitOwnerTable.toggleRowSelection(row) }
    },
    closeDialog () {
      this.loading = false
      this.afterSubmit = false
      this.finishSubmit = false
    },
    result (status) {
      // eslint-disable-next-line eqeqeq
      if (status == 'waiting') { return '等待中...' } else if (status == 'success') { return this.actiontype + '成功' } else { return this.actiontype + '失敗' }
    },
    dialogTitle () {
      if (this.finishSubmit) { return this.actiontype + '成功' } else { return '可' + this.actiontype + '戶別清單' }
    }
  }
}
</script>
<style lang="sass" scoped>
#multipleUnitOwnerDialog_main
  ::v-deep .el-dialog
    +basicDialog
    min-width: 540px
  ::v-deep .el-table
    +basicTable
    margin-bottom: 20px
    .result_success
      color: $mainColor
    .result_fail
      color: $dangerColor
  .tableTitle
    color: $mainFontColor
    text-align: left
    font-size: 19px
    font-weight: bold
    line-height: 40px
</style>
